module.exports = __webpack_public_path__ + "img/ele1.182c63da.jpg";